import { vnTemplate } from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/vnTemplate";

declare var ko: any;

export class menu_collapsible_pwa_template extends vnTemplate{

    protected getTemplateHtml(): string{

        return ` `;
    }

    protected getTemplateName(): string{
        return "menu-collapsible-pwa-template";
    }
    protected getMainElementType(): string{
        return "nav";
    }
    protected getMainElementClasses(): Array<string>{
        return ["main-nav"];
    }

    protected buildViewModel(): any{
        let self = this;

        return {
            menus: ko.observableArray([]),
            menuClick: function(menu, event){ self.menuClick(menu, event); }
        };
    }

    menuClick(menu, event){

        if(menu.level == 1) {
            menu.selected(!menu.selected());

            let defaultSectionId = this.caller.getDefaultSectionId();
            if (menu.idSection == defaultSectionId) {
                this.caller.resetGlobalSelectedBrandMenuPage();
            }

            this.caller.handleActiveMenus(menu);
        }else{

            this.caller.setGlobalSelectedBrandMenuPage(menu.id);
        }

        return true;
    }


    setMenus(menus): void{

        let sp = this.caller.getGlobalSelectedBrandMenuPage();
        let menusArray = [];
        let actives = this.caller.getActiveMenus();
        for( let m of menus ){
            let n = {id: null, identifier: null, text: "", url: "", idSection: null, selected: true, subMenus: [], cssClass: "", level: 1};
            n.id = m.id;
            n.identifier = 'identifier-1-' + m.id
            n.text = ko.observable(m.text);
            n.selected = ko.observable((actives.indexOf(m.id) != -1));
            n.idSection = m.idSection;
            n.url = m.url;
            m.subMenus.forEach((sm) => {
                sm['identifier'] = 'identifier-2-' + sm.id
                sm['cssClass'] = (sm['cssClass'].length > 0) ? " " + sm['cssClass'].join(" ") : '';
                sm['cssClass'] += (sm.id == sp) ? 'is-selected': '';
                sm['level'] = 2;
            });
            n.subMenus = ko.observable(m.subMenus);
            n.cssClass = (m.cssClass.length > 0) ? " " + m.cssClass.join(" ") : "";

            menusArray.push(n);
        }


        this.getTemplateViewModel().menus(menusArray);
    }

    public getMenus() {
        return this.getTemplateViewModel().menus();
    }

}



// WEBPACK FOOTER //
// ./js/components/templates/menu_collapsible_pwa_template.ts